"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createItem;

var _react = _interopRequireDefault(require("react"));

var _util = require("@polkadot/util");

var _KeyPair = _interopRequireDefault(require("./KeyPair"));

// Copyright 2017-2019 @polkadot/ui-keyring authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.
function createItem(address, _name) {
  let isUppercase = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  const name = (0, _util.isUndefined)(_name) ? address.length > 15 ? "".concat(address.slice(0, 6), "\u2026").concat(address.slice(-6)) : address : _name;
  return {
    key: address,
    name,
    text: _react.default.createElement(_KeyPair.default, {
      address: address,
      isUppercase: isUppercase,
      name: name
    }),
    value: address
  };
}